import { computed } from 'vue';
import { i18n } from '@/infrastructure/locales';
import type { MseProduct } from '@/types/home/product';
import { EXAMPLES, FILE_EXAMPLES } from './const';

export const getExamples = () => {
  const currentLanguage = computed(() => {
    // Use i18n.global.locale to make it reactive
    return i18n.global.locale.value; // en, cn, tw, jp
  });

  const getProductExample = (product: MseProduct) => {
    const examples = EXAMPLES[currentLanguage.value]?.[product];
    return examples ?? [];
  };

  const getProductFileExample = (product: MseProduct) => {
    const examples = FILE_EXAMPLES[currentLanguage.value]?.[product];
    return examples ?? [];
  };

  return {
    getProductExample,
    getProductFileExample,
  };
};
